import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'defaultValue'
})
export class DefaultValuePipe implements PipeTransform {

  transform(value: any,replaceVal='N.A'): any {
    
    if(!value){
      return replaceVal;
    }else{
      return value;
    }
  }

}
